//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SampleArtwork from './SampleArtwork.vue'
export default {
  components: { SampleArtwork },
  props: {
    project: {
      type: Object,
      default: null,
    },
    tokens: {
      type: Array,
      default: null,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: String,
      default: '',
    },
    activator: {
      type: Boolean,
      default: false,
    },
    editDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      limit: 9,
      overlay: false,
      selectedItem: null,
      dialog: false,
    }
  },
  computed: {
    tokenList() {
      return this.limit ? this.tokens.slice(0, this.limit) : this.tokens
    },
    fullRes() {
      const { ipfsBaseUrl } = this.$config
      if (this.selectedItem.hash) {
        console.log(this.selectedItem.link)
        return `${ipfsBaseUrl}/${this.selectedItem.hash}`
      }
      return this.selectedItem.link
    },
  },
  methods: {
    handleOpen() {
      this.dialog = true
    },
    item(item) {
      this.overlay = !this.overlay
      this.selectedItem = item
    },
    deselectItem() {
      this.selectedItem = null
      this.overlay = false
    },
  },
}
